// extracted by css-extract-rspack-plugin
export default {"ModalExternalLink":"W0dqq"};